import { render, staticRenderFns } from "./CustomerActions.vue?vue&type=template&id=4eb43bf0&"
import script from "./CustomerActions.vue?vue&type=script&lang=js&"
export * from "./CustomerActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports